// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__44d+8","line":"Footer_line__HMLlN","footerLink":"Footer_footerLink__ymr01","logo":"Footer_logo__XTWcM"};